import { RenderContent } from "components/content-renderer";

interface Props {
  data: object;
}

export const HowToSection = ({ data }: Props) => {
  return (
    <>
      <h2 className='header bg-green-default text-white px-1 pt-1'>
        How Subscriptions Work
      </h2>
      <RenderContent content={data["content"]} />
    </>
  );
};
